import './App.css';

function App() {
  return (
    <div style={{ height: "100vh", scrollbarWidth: "none",msOverflowStyle: "none", overflow: "hidden" }}>
      <iframe
        src={process.env.REACT_APP_EMBEDD_URL}
        width="100%"
        height="100%"
        allow="clipboard-write *"
        style={{ border: 'none' }}
        title="Zapier Chatbot"
      />
    </div>
  );
}

export default App;
